import { useContext } from 'react';

import { DialogContext } from '../context';

const useDialogs = () => {
  const context = useContext(DialogContext);

  if (!context) {
    throw new Error('useDialogs must be used within a DialogProvider');
  }

  return context;
};

export default useDialogs;
